<vnm-tile-card
  [header]="license.course.name"
  [subheader]="
    'assign-training.assignment-details' | translate: { learners: learners.length, course: license.course.name }
  "
>
  <vnm-empty-message
    [icon]="invites.length ? 'user-check' : 'user-times'"
    [message]="'assign-training.learners-assigned' | translate: { assigned: learners.length, errors: errors.length }"
    [loading]="running"
    loadingMessage="assign-training.assigning-learners"
    class="result-message"
  ></vnm-empty-message>
  <div [@reveal]="errors.length" class="assign-error-list">
    <div *ngFor="let error of errors" class="assign-error" @fade>
      <div class="details-wrapper">
        <fa-icon icon="exclamation-triangle"></fa-icon>
        <div class="error-details">
          <span>{{ error.message }}</span>
        </div>
      </div>
    </div>
  </div>
</vnm-tile-card>
